import { Spaces } from '../../../../api/api-spaces';
import * as types from '../constants/action-types';
import { get } from 'lodash';

export function fetchSpaceRequest () {
  return {
    type: types.SPACE_FETCH_REQUEST
  };
}

export function fetchSpaceSuccess (data) {
  return {
    type: types.SPACE_FETCH_SUCCESS,
    data
  };
}

function fetchSpaceFailure (fetchError) {
  return {
    type: types.SPACE_FETCH_FAILURE,
    fetchError
  };
}

export function updateSpaceRequest () {
  return {
    type: types.SPACE_UPDATE_REQUEST
  };
}

export function updateSpaceSuccess (data) {
  return {
    type: types.SPACE_UPDATE_SUCCESS,
    data: data.space
  };
}

function updateSpaceFailure (fetchError) {
  return {
    type: types.SPACE_UPDATE_FAILURE,
    fetchError
  };
}

function clearSpaceData () {
  return {
    type: types.SPACE_CLEAR_STORE,
    data: {}
  };
}

export function fetchSpace (query, accessToken) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchSpaceRequest());
      Spaces.read(query, accessToken, response => {
        if (200 === response.statusCode) {
          dispatch(fetchSpaceSuccess(response));

          return resolve(response);
        }

        dispatch(fetchSpaceFailure(response));
        return reject(response);
      });
    });
  };
}

export function updateSpace (id, accessToken, paylaod) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(updateSpaceRequest());
      Spaces.update(id, accessToken, paylaod, response => {
        if (200 === response.statusCode) {
          dispatch(updateSpaceSuccess(response));

          return resolve(response);
        }

        const errorMessage = get(response, 'error', 'Something went wrong. Please try again.');

        dispatch(updateSpaceFailure(errorMessage));
        return reject(errorMessage);
      });
    });
  };
}

export function clearSpaceStore () {
  return dispatch => {
    dispatch(clearSpaceData());
  };
}

export function fetchSpaceCountryStatusRequest () {
  return {
    type: types.SPACE_COUNTRY_STATUS_FETCH_REQUEST
  };
}

export function fetchSpaceCountryStatusSuccess (data) {
  return {
    type: types.SPACE_COUNTRY_STATUS_FETCH_SUCCESS,
    data: {
      countryStatus: data
    }
  };
}

export function fetchSpaceCountryStatusFailure (fetchError) {
  return {
    type: types.SPACE_COUNTRY_STATUS_FETCH_FAILURE,
    fetchError
  };
}

export function fetchSpaceCountryStatus (ssoId, accessToken) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchSpaceCountryStatusRequest());

      Spaces.read(`owner/${ssoId}/country`, accessToken, response => {
        if (200 === response.statusCode) {
          dispatch(fetchSpaceCountryStatusSuccess(response));

          return resolve(response);
        }

        dispatch(fetchSpaceCountryStatusFailure(response));
        return reject(response);
      });
    });
  };
}